<template>
  <div>

    <div class="content" style="display: block;">
      <div>
        <table cellspacing="0" style="width: 100%;">
          <thead>
            <tr>
              <th>股票名称</th>
              <th>股票代码</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataList">
              <td>{{ item.comName }}</td>
              <td>
                <div style="display: flex;justify-content: center;align-items: center;">
                  <div v-if="item.type == 'SZ'"
                    style="font-size: 13px;color: #FFFFFF;padding: 0 2px;height: 20px;line-height: 20px;margin-right: 5px;background-color: #F4CE98;">
                    {{ item.type }}</div>
                  <div v-else
                    style="font-size: 13px;color: #FFFFFF;padding: 0 2px;height: 20px;line-height: 20px;margin-right: 5px;background-color: #347CAF;">
                    {{ item.type }}</div>
                  <div>{{ item.comCode }}</div>
                </div>
              </td>
              <td>
                <div style="display: flex;justify-content: center;">
                  <div style="color: #3a8ee6;cursor: pointer;margin-right: 30px;" @click="viewOptional(item)">查看</div>
                  <div style="color: #b21f2d;cursor: pointer;" @click="deleteOption(item.comCode)">删除</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <div style="text-align: center;color: #393939;cursor: pointer;"
                  @click="$router.push({name: 'companyResearch'})"><i class="el-icon-plus"></i> 添加自选</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestCompany2 } from '../../static/js/util';

export default {
  data() {
    return {
      isLogin: false,
      dataList: null,
      runNum: 0,
    };
  },
  mounted() {
    var logState = sessionStorage.getItem('isLogin');
    if (logState != null && logState == 'true') {
      this.isLogin = true;
    }

    if(this.isLogin){
      this.getData();
    }
  },
  methods: {
    getData() {
      let url = '/company/selfCom'
      sendRequestCompany2(url, 'get', null, response => {
        // console.log(response.data)
        this.dataList = response.data.data;
      }, error => {
        console.log(error);
      })
    },
    viewOptional(row) {
      // window.location.href = '/beawanHome/companyResearch/research?comCode=' + row.comCode + '&name=' + row.comName;
      linkName(this, 'business', {comCode: row.comCode, comName: row.comName});
    },
    deleteOption(code) {
      this.$confirm('是否要移除此自选?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let url = '/company/deleteSelfCom?comCode=' + code;
        sendRequestCompany2(url, 'get', null, response => {
          if (response.data.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getData();
          } else if (response.data.code == 1) {
            this.$message.error(response.data.msg);
          } else {
            this.$message.error("删除失败");
          }
        }, error => {
          console.log(error);
        })

      }).catch(()=>{});
    }
  }
};
</script>
    
<style scoped>
table {
  width: 100%;
  text-align: center;
  /*border: 1px solid #999;*/
}

th,
td {
  height: 40px;
  line-height: 40px;
}

th {
  width: 33.3%;
  /*background-color: #e6e6e6;*/
}

td {
  border-top: 1px solid #dedede;
}
</style>